import React, { useContext, useEffect, useState } from "react";
import Indexing from "./Indexing";
import { GlobalContext } from "../context/GlobalContext";
import IndexingEntomology from "./IndexingEntomology";

function htmlDecode(input) {
  var e = document.createElement("textarea");
  e.innerHTML = input;
  // handle case of empty input
  return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
}

export default function Home(props) {
  const [isEnto, setIsEnto] = useState(false);
  const { settings } = useContext(GlobalContext);
  const [entomology, setEntomology] = React.useState(false);
  
  const [aghide, setAghide] = React.useState(false);
  const [foodhide, setFoodhide] = React.useState(false);
  const [entomohide, setEntomohide] = React.useState(false);
  const [botanyhide, setBotanyhide] = React.useState(false);

  useEffect(() => {
    const journals = [ 'www.agriculturejournal.in']
    journals.includes(settings.domain) ? setAghide(true) : setAghide(false)
  }, [settings])
  useEffect(() => {
    const journals = [ 'www.foodsciencejournal.com']
    journals.includes(settings.domain) ? setFoodhide(true) : setFoodhide(false)
  }, [settings])
  useEffect(() => {
    const journals = [ 'www.entomologyjournals.com']
    journals.includes(settings.domain) ? setEntomohide(true) : setEntomohide(false)
  }, [settings])
  useEffect(() => {
    const journals = [ 'www.botanyjournals.com']
    journals.includes(settings.domain) ? setBotanyhide(true) : setBotanyhide(false)
  }, [settings])
  
  useEffect(() => {
    document.title = settings.websitename;

    // Adjusted logic to correctly set entomology state based on domain
    const journals_entomology = ["www.entomologyjournals.com"];
    setEntomology(journals_entomology.includes(settings.domain));
  }, [settings]);

  useEffect(() => {
    if (window.location.hostname === "www.entomologyjournals.com") {
      setIsEnto(true);
    }
  }, []);

  // www.entomologyjournals.com

  return (
    <>
      <div className="flex flex-col items-center w-full gap-6 text-3xl font-bold text-blue-A">
        <div className="text-center">
          {isEnto && (
            <a href="https://mjl.clarivate.com://search-results?issn=2455-4758&hide_exact_match_fl=true&utm_source=mjl&utm_medium=share-by-link&utm_campaign=search-results-share-this-journal">
              <img
                className="w-3/5 m-auto blinkBox"
                src="/assets/images/R.png"
                alt="image webSci"
              />
            </a>
          )}
        </div>
        <div className="text-center">
          {/* {!entomology && <IndexingEntomology />} <br /> */}
          {settings && settings.issn && settings.issn.split(",")[0]}
          <br />
          {settings && settings.issn && settings.issn.split(",")[1]}
        </div>
        <div className="text-center">
          Indexed Journal
          <br />
          Refered Journal
          <br />
          Peer Reviewed Journal
        </div>
        <div className="text-center">
          We send published link, <br />
          certificate, coverpage
        </div>
      </div>
      {aghide && (<div className="w-1/4 pt-2 text-xl font-bold text-green-600 blinkBox">NAAS SCORE 2024: 4.83</div>)}
      {foodhide && (<div className="w-1/4 pt-2 text-xl font-bold text-green-600 blinkBox">NAAS SCORE 2024: 4.56</div>)}
      {entomohide && (<div className="w-1/4 pt-2 text-xl font-bold text-green-600 blinkBox">NAAS SCORE 2024: 4.41</div>)}
      {botanyhide && (<div className="w-1/4 pt-2 text-xl font-bold text-green-600 blinkBox">NAAS SCORE 2024: 4.37</div>)}
      <div
        className="pt-6"
        dangerouslySetInnerHTML={{
          __html:
            typeof window !== "undefined"
              ? htmlDecode(settings.home_content || "")
              : "",
        }}
      ></div>
      <div id="indexing-title">INDEXING</div>
      <Indexing />
    </>
  );
}
